import React, { useEffect } from 'react'
import { useSelector, useDispatch} from 'react-redux'
import { useLocation } from 'react-router-dom'
import Navbar from '../components/login/Navbar'
import FormWrapper from '../components/login/FormWrapper'
import WarnSection from '../components/WarnSection'
import styled from 'styled-components'
import { selectLoginState, removeLoginError} from '../features/login/loginSlice'

const Login = () => {

  const location = useLocation()  
  const dispatch = useDispatch()
  const loginState = useSelector(selectLoginState)

  useEffect(()=>{
    dispatch(removeLoginError())
  },[location])

  return (
    <Wrapper>
        {
          loginState.isError &&  <WarnSection error_message={loginState.error}/>
        }
        <Navbar/>
        <FormWrapper />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow: auto;
  height: 100vh; 
`;


export default Login
